import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Sidebar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const menu = [
    { name: "Dashboard", path: "/" },
    { name: "Add Lead (Calling EOI)", path: "/add-lead-wizard" },
    { name: "My Applied Leads (EOI Applied For)", path: "/my-leads" },
    { name: "Explore Value Pod Leads Universe", path: "/explore" },
  ];

  const accountMenu = [
    { name: "Update Profile", path: "/profile" },
    { name: "Change Password", path: "/change-password" },
  ];

  const logout = () => {
    localStorage.removeItem("noatoken");
    navigate("/login");
  };

  return (
    <div className="w-64 bg-white shadow-lg p-6 flex flex-col justify-between">
      
      {/* TOP SECTION */}
      <div>
        <h2 className="text-2xl font-bold text-green-600 mb-8">
          NoaPod
        </h2>

        <div className="space-y-2">
          {menu.map((m) => (
            <Link
              key={m.path}
              to={m.path}
              className={`block p-3 rounded-lg ${
                pathname === m.path
                  ? "bg-green-100 text-green-700"
                  : "hover:bg-gray-100"
              }`}
            >
              {m.name}
            </Link>
          ))}
        </div>
      </div>

      {/* BOTTOM SECTION (ACCOUNT) */}
      <div className="border-t pt-4 space-y-2">
        <p className="text-sm text-gray-500 mb-2">Account</p>

        {accountMenu.map((m) => (
          <Link
            key={m.path}
            to={m.path}
            className="block p-2 rounded hover:bg-gray-100 text-sm"
          >
            {m.name}
          </Link>
        ))}

        <button
          onClick={logout}
          className="w-full text-left p-2 rounded hover:bg-red-100 text-red-600 text-sm"
        >
          Logout
        </button>
      </div>
    </div>
  );
}